<template>
  <div class="table-responsive text-wrap">
    <a-table :columns="columns" :row-key="data.id" :data-source="data" :pagination="false" :loading="loading">
      <template #general="{ text }">
        <a-row class="small">
          <a-col class="font-weight-bold" :lg="{ span: 8 }">
            Carta Porte
          </a-col>
          <a-col :lg="{ span: 16 }">
            Traslado
          </a-col>
        </a-row>
        <hr class="bg-success">
        <a-row class="small">
          <a-col class="font-weight-bold" :lg="{ span: 8 }">
            Remisión
          </a-col>
          <a-col :lg="{ span: 16 }">
            {{ text.shipment }}
          </a-col>
        </a-row>
        <hr class="bg-success">
        <a-row class="small">
          <a-col class="font-weight-bold" :lg="{ span: 8 }">
            Entrega
          </a-col>
          <a-col :lg="{ span: 16 }">
            {{ text.deliveryCode }}
          </a-col>
        </a-row>
        <hr class="bg-success">
        <a-row class="small">
          <a-col class="font-weight-bold" :lg="{ span: 8 }">
            Cliente
          </a-col>
          <a-col :lg="{ span: 16 }">
            {{ text.client }}
          </a-col>
        </a-row>
      </template>
      <template #material="{ text }">
        <a-row class="small">
          <a-col class="font-weight-bold" :lg="{ span: 8 }">
            Obra
          </a-col>
          <a-col :lg="{ span: 16 }">
            {{ text.constructionSiteCode }}
          </a-col>
        </a-row>
        <hr class="bg-success">
        <a-row class="small">
          <a-col class="font-weight-bold" :lg="{ span: 8 }">
            Cantidad
          </a-col>
          <a-col :lg="{ span: 16 }">
            {{ text.quantityM3 }} m3
          </a-col>
        </a-row>
        <hr class="bg-success">
        <a-row class="small">
          <a-col class="font-weight-bold" :lg="{ span: 8 }">
            Producto
          </a-col>
          <a-col :lg="{ span: 16 }">
            {{ text.product }}
          </a-col>
        </a-row>
      </template>
      <template #status="{ text }">
        <span class="text-warning font-weight-bold" v-if="text.status === 'Pendiente'">
          {{ text.status }}
        </span>
        <span class="text-success font-weight-bold" v-if="text.status === 'Concluida'">
          {{ text.status }}
        </span>
        <span class="text-info font-weight-bold" v-if="text.status === 'Programada'">
          {{ text.status }}
        </span>
        <span class="text-danger font-weight-bold" v-if="text.status === 'Rechazada'">
          {{ text.status }}
        </span>
      </template>
      <template #details="{ text }">
        <span class="font-weight-bold">
        {{ text.user.name }}
        </span>
      </template>
      <template #action="{ text }">
        <a-row>
          <router-link class="btn btn-sm btn-outline-danger mr-2"
            :to="{ path: `/carta_porte/pdf/${text.id}`, params: { consignmentNoteId: text.id } }">
            <i class="fe fe-file-text mr-2" />
            PDF
          </router-link>
        </a-row>
      </template>
    </a-table>

    <a-modal :closable="false" :visible="visible" title="Actualizar Información de Catálogos">

      <a-form :model="formProcess" ref="ruleForm" :rules="rules" @finish="submit" layout="vertical" label-align="left">

        <a-form-item label="Información a Actualizar:" name="process" required>
          <a-select placeholder="Seleccione la información a actualizar" :value="formProcess.process"
            @change="handleChange" style="width: 100%">
            <a-select-option v-for="item in processOptions" :key="item.key" :value="item.key">
              {{ item.value }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <error-manager-component v-if="errorHandler.errorDescription.errors.length > 0"
          :errors="errorHandler.errorDescription.errors" />

        <a-row class='py-1'>
          <a-col span="8" offset="10" v-if="formLoad">
            <a-spin tip="Cargando..." />
          </a-col>
          <a-col span="12" class="pt-1 pl-1" offset="6" v-else>
            <button type="submit" style="width: 100%" class="btn bg-holcim-bright-green text-white">
              <i class="fe fe-save" />
              Actualizar
            </button>
          </a-col>
        </a-row>

      </a-form>

      <template #footer>
        <a-button key="back" @click="closeModal">
          <i class='fe fe-x-circle pr-2' />
          Cerrar
        </a-button>
      </template>
    </a-modal>

  </div>
</template>

<script>

import ErrorManagerComponent from "../../../components/errorManagerComponent";
import useConsignmentNote from "../../../composables/useConsignmentNote";

const columns = [
  {
    title: 'Información General',
    dataIndex: '',
    slots: { customRender: 'general' },
    class: 'text-center',
  },
  {
    title: 'Material',
    dataIndex: '',
    slots: { customRender: 'material' },
    class: 'text-center',
  },
  {
    title: 'Usuario',
    dataIndex: '',
    slots: { customRender: 'details' },
    class: 'text-center',
  },
  {
    title: 'Estatus',
    dataIndex: '',
    slots: { customRender: 'status' },
    class: 'text-center',
  },
  {
    title: 'Acciones',
    slots: { customRender: 'action' },
    class: 'text-center',
  },
]

export default {
  name: "MainTable",
  components: { ErrorManagerComponent },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    data: {
      type: [Object],
      require: true,
      defaultValue: {},
    },
    // eslint-disable-next-line vue/require-default-prop
    loading: {
      type: [Boolean],
      require: true,
      defaultValue: false,
    },
  },
  setup() {

    const {
      visible,
      openModal,
      closeModal,
      updateType,
      formLoad,

      processOptions,
      formProcess,
      rules,
      submit,
      errorHandler,
      handleChange,
    } = useConsignmentNote()

    return {
      columns,
      visible,
      openModal,
      closeModal,
      updateType,
      formLoad,

      processOptions,
      formProcess,
      rules,
      submit,
      errorHandler,
      handleChange,
    }
  },
}
</script>

<style scoped></style>
